import { useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import Typeahead from '../../../../CommonElements/TypeAhead';
import { CommentTxt, NotifyCustomer, OrderStatus, OverRide, Save } from '../../../../Constant';
import { postClientUrlWithToken } from '../../../../Utils/restUtils';
import { useSelector } from 'react-redux';
import { addCustomerSubscription, addCustomerSubscriptionRole, postOrderHistory, postOrderHistoryRole } from '../../../../CommonUrl';
import { Btn } from '../../../../AbstractElements';
import Transparentspinner from '../../../Common/Loader/Transparentspinner';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import HandleApiError from '../../../Common/ErrorImport/ErrorImport';


const ModalStatus = ({ orderId, onClose, clearselectedRows }) => {
    const authState = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const { register, handleSubmit, control, formState: { errors } } = useForm({});
    const [spinnerTrans, setspinnerTrans] = useState(false)
    const options = [
        { value: "pending", label: "Pending" },
        { value: "processing", label: "Processing" },
        { value: "shipped", label: "Shipped" },
        { value: "delivered", label: "Delivered" },
        { value: "cancelled", label: "Cancelled" },
        { value: "failed", label: "Failed" },
    ];

    const submit = async (data) => {
        setspinnerTrans(true)
        const postRequest = {
            order_id: orderId,
            status: data.status?.value,
            comments: data.comment,
            customer_notify: data.notify === 0 ? 'no' : 'yes',
        }
        const addCustomerSubscriptionResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? postOrderHistory : postOrderHistoryRole, postRequest);
        if (addCustomerSubscriptionResponse.status === 200) {
            if (addCustomerSubscriptionResponse.data.status === true) {
                toast.success(addCustomerSubscriptionResponse.data.message);
                onClose();
                clearselectedRows();
            } else {
                toast.error(addCustomerSubscriptionResponse.data.message);
                setspinnerTrans(false)
            }
        } else {
            HandleApiError(navigate, addCustomerSubscriptionResponse.status)
        }
        setspinnerTrans(false)
    };

    return (
        <>
            {spinnerTrans && <Transparentspinner />}
            <div className='col-md-12'>
                <div className="d-flex" >
                    <div className='recent-circle bg-primary'></div>
                    <div className="flex-grow-1">
                        <Form className="needs-validation" noValidate onSubmit={handleSubmit(submit)}>
                            <Row>
                                <Col md="6">
                                    <Label className="form-label" >{OrderStatus}</Label>
                                    <Controller
                                        name="status"
                                        control={control}
                                        render={({ field }) => (
                                            <Typeahead
                                                options={options}
                                                onChange={(value) => {
                                                    field.onChange(value);
                                                }}
                                                value={field.value}
                                            />
                                        )}
                                    />
                                    <p className="text-danger">{errors.account?.message}</p>
                                </Col>
                                <Col style={{ marginTop: '30px' }}>
                                    <Label style={{ paddingLeft: '40px' }} for="chk-ani1">
                                        <Controller
                                            name="notify"
                                            control={control}
                                            defaultValue={0}
                                            render={({ field }) => (
                                                <Input
                                                    type="checkbox"
                                                    id="chk-ani1"
                                                    className="checkbox_animated"
                                                    checked={field.value === 1}
                                                    onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                                />
                                            )}
                                        />
                                        {NotifyCustomer}
                                    </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="form-label">{CommentTxt}</Label>
                                    <textarea className="form-control"
                                        {...register("comment")}
                                        maxLength={60}
                                    />
                                    <p className="text-danger">{errors.address?.message}</p>
                                    {errors.address?.type === 'maxLength' && <p>Comment must not exceed 160 characters</p>}
                                </Col>
                            </Row>
                            <FormGroup>
                            </FormGroup>
                            <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalStatus